import { IStore } from '@/store/types';
import { IModuleState } from './types';
import * as actions from './actions';
import * as mutations from './mutations';

const initialState = {
  encryptionType: { data: [], raw: [], loading: false },
  messageType: { data: [], raw: [], loading: false },
  emailList: { data: [], loading:  false },
  smsList: { data: [], loading:  false },
};

export default { namespaced: true, state: initialState, actions, mutations } as IStore<IModuleState>;
